import React, { useEffect, useImperativeHandle, useState } from 'react';
import { withTranslation } from "react-i18next";
import { withRouter, useLocation } from "react-router-dom";
import { DigitalVaultHomeView } from '../../views';

function DigitalVaultHomeAction(props) {
    const {
        toggleErrorRequesting,
        viewAsCards,
        setViewAsCards,
        tabRef,
    } = props;

    const { state } = useLocation();
    const [companies, setCompanies] = useState([]);
    const [selectedCompany, setSelectedCompany] = useState(null);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [subcategoryPath, setSubcategoryPath] = useState([]);
    const [selectedDocument, setSelectedDocument] = useState(null);

    useEffect(() => {
        if (state) {
            setSelectedCompany(state.selectedCompany);
            setSelectedCategory(state.selectedCategory);
            setSubcategoryPath(state.subcategoryPath);
            setSelectedDocument(state.selectedDocument);
        }
    }, [])

    const [breadcrumbItems, setBreadcrumbItems] = useState([]);

    useEffect(() => {
        let items = []

        if (selectedCompany) {
            items.push({
                id: 0,
                title: selectedCompany.company.companyName,
            })
        };

        setBreadcrumbItems(items);
    }, [selectedCompany]);

    useEffect(() => {
        if (selectedCategory) setBreadcrumbItems((prev) => [...prev, { id: 1, title: selectedCategory.name }])
    }, [selectedCategory]);

    useEffect(() => {
        if (subcategoryPath && subcategoryPath.length) {
            setBreadcrumbItems((prev) => [prev[0], prev[1], ...subcategoryPath.map(s => ({ id: s.subcategory.id, title: s.subcategory.name }))])
        }
    }, [subcategoryPath]);

    const handleBreadcrumbClick = (event, item) => {
        event.preventDefault();
        const itemIndex = breadcrumbItems.findIndex((i) => i.id == item.id);
        const newData = breadcrumbItems.slice(0, itemIndex + 1);

        if (itemIndex == 0) {
            setSelectedCategory(null);
        }
        if (itemIndex <= 1) {
            setSubcategoryPath([]);
        } else {
            const pathIndex = subcategoryPath.findIndex((i) => i.subcategory.id == item.id);
            const newPath = subcategoryPath.slice(0, pathIndex + 1);
            setSubcategoryPath(newPath);
        }
        setBreadcrumbItems(newData);
    };

    const newDocument = () => ({
        companyId: selectedCompany?.company.id,
        categoryId: selectedCategory?.id,
        subcategoryPath: subcategoryPath.map(i => i.subcategory.id).join(',')
    })

    const clearData = () => {
        setSelectedCompany(null);
        setSelectedCategory(null);
        setSubcategoryPath([]);
        setSelectedDocument(null);
    }

    useImperativeHandle(
        tabRef,
        () => ({ newDocument, clearData }),
        [selectedCompany, selectedCategory, subcategoryPath],
    )

    return (
        <DigitalVaultHomeView
            toggleErrorRequesting={toggleErrorRequesting}

            viewAsCards={viewAsCards}
            setViewAsCards={setViewAsCards}
            breadcrumbItems={breadcrumbItems}
            handleBreadcrumbClick={handleBreadcrumbClick}

            companies={companies}
            setCompanies={setCompanies}
            selectedCompany={selectedCompany}
            setSelectedCompany={setSelectedCompany}

            selectedCategory={selectedCategory}
            setSelectedCategory={setSelectedCategory}

            selectedDocument={selectedDocument}
            setSelectedDocument={setSelectedDocument}

            subcategoryPath={subcategoryPath}
            setSubcategoryPath={setSubcategoryPath}
        />
    )
}

export default withRouter(withTranslation()(DigitalVaultHomeAction));